import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { SortDirection } from "../../tables/table";
import { ReportFilterSchema } from "./filters/report-filter";
import { ReportDataType } from "./report-data-type";

// Mirror all changes to this file in redo/server/src/models/Report.ts

const ReportScheduleSchema_ = z.object({
  enabled: z.boolean(),
  emailAddresses: z.array(z.string()),
  cron: z.string(),
  nextReport: z.date().optional(),
});
const ReportScheduleSchema: z.ZodType<ReportSchedule> = ReportScheduleSchema_;
export interface ReportSchedule extends z.infer<typeof ReportScheduleSchema_> {}

export const ReportSchema_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  name: z.string(),
  dataType: createEnum(ReportDataType),
  columns: z.array(z.string()),
  sortKey: z.string().optional(),
  sortDirection: createEnum(SortDirection).optional(),
  filters: z.array(ReportFilterSchema),
  schedule: ReportScheduleSchema.optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
/* TODO(paul)
  // Enforce that filters are valid for the data type
  .superRefine(({ dataType, filters }, ctx) => {
    const validTypes = getValidFilterTypes(dataType);
    const invalidFilters = filters.filter(
      (filter) => !validTypes.includes(filter.type),
    );

    for (const filter of invalidFilters) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_enum_value,
        message: `Invalid filter type "${filter.type}" for data type "${dataType}"`,
        received: filter.type,
        options: validTypes,
      });
    }
  })
  .innerType();
  */
export const ReportSchema: z.ZodType<Report> = ReportSchema_;
export interface Report extends z.infer<typeof ReportSchema_> {}
